<template>
  <v-container class="pa-0 mx-0">
    <ForgotPassword />  <!-- Include the Login component from components/auth -->
  </v-container>
</template>

<script>
import ForgotPassword from '@/components/auth/ForgotPassword.vue'; // Import the Login component

export default {
  components: {
    ForgotPassword,
  },
};
</script>

<style scoped>
/* You can add styles specific to the login page here */
</style>
